// /project-overview/report?overview=&key=&analysis=&direction=&mp= — the target of
// every link in the Corridor Safety Summary PDF. The PDF never carries the report
// file's own address: the reader lands here, signs in (the route is inside the
// authenticated layout), the server checks the project assignment and only then
// hands back the report URL.
import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../Safety/SafetyDashboard.css';
import './ProjectOverview.css';
import { fetchReportLink } from './overviewApi';

export default function OverviewReportRedirect() {
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const overview = params.get('overview');
  const key = params.get('key');
  const analysis = params.get('analysis');
  const direction = params.get('direction');
  const mp = params.get('mp');

  useEffect(() => {
    let live = true;
    if (!overview || !key || !analysis || !mp) {
      setError('This report link is incomplete.');
      return undefined;
    }
    fetchReportLink(overview, { key, analysis, direction, mp })
      .then((d) => { if (live) window.location.replace(d.url); })
      .catch((e) => {
        if (!live) return;
        setError(e.status === 401
          ? 'Sign in to 123bimlive first, then open the link from the PDF again.'
          : e.status === 404
            ? 'This report is not available to your account. Ask for access to the project, or check that the overview still exists.'
            : e.message);
      });
    return () => { live = false; };
  }, [overview, key, analysis, direction, mp]);

  return (
    <div className="safety-dashboard ov-dashboard">
      <div className="ov-redirect">
        <h1>{error ? 'The report could not be opened' : `Opening the ${analysis || ''} report…`}</h1>
        {error ? <p className="safety-muted">{error}</p> : <p className="safety-muted">Checking your access to the project.</p>}
        <p><Link to="/safety-dashboard" className="ov-report">Go to the Safety Dashboard</Link></p>
      </div>
    </div>
  );
}
